import type {
  AssessmentCommentFilter,
  AssessmentFilter,
  AssessmentResultFilter,
  CalculateGradeFilter,
  CommentBankFilter,
  DashboardAssessmentFilter,
  GradeFilter,
  GradeSetFilter,
  OverallCommentsFilter,
  Print_AssessmentOptions,
  StudentResultFilter,
} from '@tyro/api';

export type AllGradeFilter = {
  gradeSetId: number;
};

export const assessmentsKeys = {
  all: ['assessments'] as const,
  print: (filter: Print_AssessmentOptions) => [
    ...assessmentsKeys.all,
    'print',
    filter,
  ],
  assessments: (filter: AssessmentFilter) =>
    [...assessmentsKeys.all, filter] as const,
  assessmentsExtraFields: (filter: AssessmentFilter) =>
    [...assessmentsKeys.all, 'extraFields', filter] as const,
  resultsBySubjectGroup: (
    academicNamespaceId: number,
    filter: AssessmentResultFilter,
  ) =>
    [...assessmentsKeys.all, 'results', academicNamespaceId, filter] as const,
  calculateGrade: (academicNamespaceId: number, filter: CalculateGradeFilter) =>
    [...assessmentsKeys.all, 'grade', academicNamespaceId, filter] as const,
  commentBanks: () => [...assessmentsKeys.all, 'commentBanks'] as const,
  commentBanksWithComments: (filter: CommentBankFilter) =>
    [...assessmentsKeys.commentBanks(), filter] as const,
  studentDashboardAssessments: (
    filter: DashboardAssessmentFilter,
    academicNamespaceId: number | string,
  ) => [...assessmentsKeys.all, 'dashboard', academicNamespaceId, filter],
  assessmentResultsForStudent: (
    academicNamespaceId: number,
    filter: StudentResultFilter,
  ) => [
    ...assessmentsKeys.all,
    'assessmentResultsForStudent',
    academicNamespaceId,
    filter,
  ],
  gradeSets: (filter: GradeSetFilter) =>
    [...assessmentsKeys.all, 'gradeSets', filter] as const,
  grades: (filter: GradeFilter) =>
    [...assessmentsKeys.all, 'grades', filter] as const,
  allAssessmentComments: () => [...assessmentsKeys.all, 'assessmentComments'],
  assessmentComments: (
    academicNamespaceId: number,
    filter: AssessmentCommentFilter,
  ) => [
    ...assessmentsKeys.allAssessmentComments(),
    academicNamespaceId,
    filter,
  ],
  allOverallCommentsByYearGroup: () => [
    ...assessmentsKeys.all,
    'overallCommentsByYearGroup',
  ],
  overallCommentsByYearGroup: (
    academicNamespaceId: number,
    filter: OverallCommentsFilter,
  ) => [
    ...assessmentsKeys.allOverallCommentsByYearGroup(),
    academicNamespaceId,
    filter,
  ],
  programmeStage: () => [...assessmentsKeys.all, 'programmeStage'] as const,
};
